import { ReactElement } from "react";
import { IconsProps } from "../../icons/dto";
import { ReportIcon } from "../../icons/reportIcon";
import { SettingIcon } from "../../icons/settingIcon";

export enum MenuItems {
  REPORT = "REPORT",
  SETTINGS = "SETTINGS",
}

export const MenuItemsLabelMap = new Map<MenuItems, string>([
  [MenuItems.REPORT, "Report"],
  [MenuItems.SETTINGS, "Impostazioni"],
]);

export const MenuItemsHrefMap = new Map<MenuItems, string>([
  [MenuItems.REPORT, "/report"],
  [MenuItems.SETTINGS, "/settings"],
]);

export const PathMenuItemMap = new Map<string, MenuItems>([
  ["report", MenuItems.REPORT],
  ["settings", MenuItems.SETTINGS],
]);

export const menuItemsIconMap = new Map<MenuItems, ReactElement<IconsProps, React.FunctionComponent<IconsProps>>>([
  [MenuItems.REPORT, <ReportIcon color="" size={20} />],
  [MenuItems.SETTINGS, <SettingIcon color="" size={20} />],
]);

export function MenuItemsIconsMap(
  menuItem: MenuItems,
  color: string,
  size: number
): ReactElement {
  const map = new Map<MenuItems, ReactElement>([
    [MenuItems.REPORT, <ReportIcon color={color} size={size} />],
    [MenuItems.SETTINGS, <SettingIcon color={color} size={size} />]
  ]);

  return map.get(menuItem) as ReactElement;
}
